import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { PlusSquareOutlined } from '@ant-design/icons'
import { Card, Col, Pagination, Select, Space, Spin, Switch } from 'antd'
import OrderInfoContainer from '@a4b/ui/src/modules/monetisation/molecules/OrderInfoContainer'
import TempleListItemInfo from './TempleListItemInfo'
import { STORE_SERVICE_TYPE, Store, Stores, TempleData } from '@a4b/api/src/modules/Monetisation/Offerings/types'
import { Input } from 'antd'
import { TempleList } from '@/../../../packages/a4b-api/src'

const { Search } = Input
interface FiltersType {
  serviceType: STORE_SERVICE_TYPE | undefined
  storeId: string | undefined
}
interface Props {
  data: Stores | undefined
  hubId: string
  hubName: string | null
  paginationOnChange: (page: number, pageSize: number) => void
  currentPage: number
  totalRecords: number
  dataRecords: Store[]
  showAddNewTemple: boolean
  pageSize: number,
  updateFilters: (type: string, value: string) => void
  filters: FiltersType
  isLoading: boolean
  getHubManagersList: () => void
  templeListing: boolean
  onToggleTempleListing: (value: boolean) => void
  templeListPaginated: TempleData[]
}

const Container = styled(Card)`
  display: flex;
  flex-direction: column;

  .ant-card-body {
    flex-grow: 1;
  }
`
const ButtonContainer = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: start;
`
const LabelRightAlign = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  height: 100%;
`
const TempleListPage: React.FC<Props> = ({
  data,
  hubName,
  hubId,
  paginationOnChange,
  currentPage,
  totalRecords,
  dataRecords,
  showAddNewTemple,
  pageSize,
  updateFilters,
  filters,
  isLoading,
  getHubManagersList,
  templeListing,
  onToggleTempleListing,
  templeListPaginated
}) => {

  const refreshTempleListingData = async () => {
    getHubManagersList()
  }

  return (
    <Container
      title={<div style={{ display: "flex", justifyContent: "space-between" }}>
        {`Hub Name : ${hubName}`}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <span>Temple Listing</span>
          <Switch checked={templeListing} onChange={onToggleTempleListing} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ width: '100%', marginRight: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <label style={{ marginRight: '5px' }}> Search By: </label>
            {templeListing ? (
              <Search
                placeholder='Temple Id'
                style={{ marginRight: '10px', width: '400px' }}
                onSearch={(value: string) => {
                  updateFilters('templeId', value)
                }}
                allowClear
              />
            ) : (
              <Search
                placeholder='Store Id'
                style={{ marginRight: '10px', width: '400px' }}
                onSearch={(value: string) => {
                  updateFilters('storeId', value)
                }}
                allowClear
              />
            )}

          </div>
          <div style={{ width: '100%' }}>
            {/* <label style={{ marginRight: '5px' }}> Filters: </label> */}
            <Select style={{ width: '150px' }} value={filters?.serviceType} allowClear placeholder="Service type" defaultValue="offerings" onChange={(value: string) => {
              updateFilters('serviceType', value)
            }}>
              <Select.Option value="pooja">Pooja</Select.Option>
              <Select.Option value="offerings">Offering</Select.Option>
            </Select>
          </div>
        </div>
      </div>}
      style={{ width: '100%', height: '100%' }}
    >
      <Space direction={'vertical'} style={{ width: '100%' }}></Space>
      {
        isLoading ?
          <Spin /> :
          <OrderInfoContainer
            activeBatchesCount={data?.total_active_batches || 0}
          ></OrderInfoContainer>
      }
      {showAddNewTemple && (
        <ButtonContainer>
          <Link to='/monetisation/offerings/temple/create'>
            <PlusSquareOutlined /> Add new Temple
          </Link>
        </ButtonContainer>

      )}
      {
        isLoading ?
          <Col style={{ width: '100%', minHeight: '50vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Spin />
          </Col> :
          <>
            {(templeListing ? (templeListPaginated || []) : dataRecords).map((item) => {
              const normalizedData: Store = templeListing
                ? {
                  id: (item as TempleData).temple_id,
                  name: (item as TempleData).name,
                  city: (item as TempleData).city,
                  service_type: (item as TempleData).stores_data?.[0]?.service_type || 'offerings',
                  store_type: (item as TempleData).stores_data?.[0]?.store_type || 'regular',
                  total_active_batches: (item as TempleData).total_active_batches,
                }
                : (item as Store)

              return (
                <TempleListItemInfo
                  data={normalizedData}
                  key={normalizedData.id}
                  link={`/monetisation/offerings/hub/${hubId}/temple/${normalizedData.id}/batch?name=${normalizedData.name}`}
                  onBatchGenerated={refreshTempleListingData}
                  storeList={templeListing ? (item as TempleData)?.stores_data : []}
                  templeListing={templeListing}
                />
              )
            })}


            <LabelRightAlign>
              <Pagination
                defaultPageSize={pageSize}
                defaultCurrent={1}
                current={currentPage}
                total={totalRecords}
                onChange={paginationOnChange}
                showSizeChanger
              />
            </LabelRightAlign>
          </>
      }
    </Container>
  )
}

export default TempleListPage
